import { combine } from 'zustand/middleware';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState, _getState) { return ({
        addModal: function (value) {
            setState(function (state) {
                return { content: state.content.concat(value) };
            });
        },
        removeModal: function (value) {
            setState(function (state) {
                return { content: state.content.filter(function (el) { return el.id !== value; }) };
            });
        },
        hideLastModal: function () {
            setState(function (state) {
                return { content: state.content.splice(0, -1) };
            });
        },
    }); });
};
